import { render, staticRenderFns } from "./AccountMyNotesNote.vue?vue&type=template&id=6956890d&"
import script from "./AccountMyNotesNote.vue?vue&type=script&lang=js&"
export * from "./AccountMyNotesNote.vue?vue&type=script&lang=js&"
import style0 from "./AccountMyNotesNote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports